function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { ExternalTrackingExeption } from 'internals/exceptionHandler';
import { getFileName, getPlatform, getBatchEventsFlag, filterPropertiesByPatterns } from 'internals/helpers';
import amplitude from './lib';
import GeneralEventTrackingDispatcher from '../GeneralEventTrackingDispatcher';
import { OMITTED_PROPERTY_PATTERNS } from '../../constants';
var amplitudeInstance;
var AmplitudeEventDispatcher = /*#__PURE__*/function (_GeneralEventTracking) {
  /*
  * This class is an interface for connecting to Amplitude SDK.
  * It is responsible for encapsulating all amplitude SDK calls, and exposing general event to the application.
  * Always use the factory getAmplitudeEventDispatcherInstance to instantiate this class.
  */
  function AmplitudeEventDispatcher(_ref) {
    var _this;
    var userFetcher = _ref.userFetcher;
    _classCallCheck(this, AmplitudeEventDispatcher);
    _this = _callSuper(this, AmplitudeEventDispatcher, [{
      userFetcher: userFetcher
    }]);
    if (process.env.AMPLITUDE_API_KEY && !process.env.SERVER && amplitude.getInstance) {
      _this.amplitudeInstance = amplitude.getInstance();
      _this.amplitudeInstance.init(process.env.AMPLITUDE_API_KEY, null, {
        deviceIdFromUrlParam: true,
        // for AMP pages
        includeUtm: true,
        includeGclid: true,
        includeReferrer: true,
        batchEvents: getBatchEventsFlag(),
        eventUploadThreshold: 5
      });
      _this.sessionId = _this.amplitudeInstance.getSessionId();
    }
    return _this;
  }
  _inherits(AmplitudeEventDispatcher, _GeneralEventTracking);
  return _createClass(AmplitudeEventDispatcher, [{
    key: "setUserProperties",
    value: function setUserProperties(payload) {
      var fetchUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      try {
        if (!payload) {
          this.setDefaultUserProperties();
          return;
        }
        if (fetchUser) {
          this.user = this.validUserFetcher();
        }
        var parsedUser = this.user;
        this.amplitudeInstance.setUserId(parsedUser.user_id);
        this.amplitudeInstance.setUserProperties(filterPropertiesByPatterns(payload, OMITTED_PROPERTY_PATTERNS.amplitude));
        this.amplitudeInstance.setVersionName(process.env.BUILD);
      } catch (e) {
        throw new ExternalTrackingExeption({
          message: "Error on setUserProperties: ".concat(JSON.stringify(e.message)),
          fileName: getFileName(__filename),
          externalTrackingService: 'Amplitude',
          extra: {
            payload: payload
          }
        });
      }
    }
  }, {
    key: "setDefaultUserProperties",
    value: function setDefaultUserProperties() {
      var fetchUser = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      try {
        if (fetchUser) {
          this.user = this.validUserFetcher();
        }
        var parsedUser = this.user;
        this.amplitudeInstance.setUserId(parsedUser.user_id);
        this.amplitudeInstance.setUserProperties({
          login_status: parsedUser.login_status,
          platform: getPlatform(),
          web_mobile_mode: this.webMobileMode
        });
        this.amplitudeInstance.setVersionName(process.env.BUILD);
      } catch (e) {
        throw new ExternalTrackingExeption({
          message: "Error on setDefaultUserProperties: ".concat(JSON.stringify(e.message)),
          fileName: getFileName(__filename),
          externalTrackingService: 'Amplitude'
        });
      }
    }
  }, {
    key: "logWithDefaultEventProps",
    value: function logWithDefaultEventProps(eventName, state, extraProperties) {
      try {
        var eventProps = {};
        Object.assign(eventProps, this.createMainEventProperties(state));
        Object.assign(eventProps, extraProperties);
        this.amplitudeInstance.logEvent(eventName, eventProps);
      } catch (e) {
        throw new ExternalTrackingExeption({
          message: "Error on logWithDefaultEventProps: ".concat(JSON.stringify(e.message)),
          fileName: getFileName(__filename),
          externalTrackingService: 'Amplitude'
        });
      }
    }
  }, {
    key: "logWithDefaultProps",
    value: function logWithDefaultProps(eventName, state, extraProperties) {
      var fetchUser = eventName.includes('login');
      this.setDefaultUserProperties(fetchUser);
      this.logWithDefaultEventProps(eventName, state, extraProperties);
    }
  }, {
    key: "identify",
    value: function identify(_identify) {
      this.amplitudeInstance.identify(_identify);
    }
  }]);
}(GeneralEventTrackingDispatcher);
var getAmplitudeEventDispatcherInstance = function getAmplitudeEventDispatcherInstance(userFetcher) {
  /*
  * Factory responsible for generatign a singleton. Only one instance of EventDispatcherHandler must exist at a time.
  */
  if (!process.env.AMPLITUDE_API_KEY) {
    return undefined;
  }

  if (amplitudeInstance) {
    return amplitudeInstance;
  }
  amplitudeInstance = new AmplitudeEventDispatcher({
    userFetcher: userFetcher
  });
  return amplitudeInstance;
};
export { AmplitudeEventDispatcher };
export default getAmplitudeEventDispatcherInstance;
